import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";
import useRouteInfo from "../../useRouteInfo";
import { useRouter } from "../../useRouter";
import { useBookingSlotsListAPI } from "../bookings/useBookingSlotsListAPI";

export const useRefetchAvailableSlots = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("SLOTS", "id"));
  const { filters } = routeState.state as ISlotsState;
  const fetchAvailableSlots = useBookingSlotsListAPI();

  const execute = () => {
    if (filters) {
      let copyFilters = filters;
      if (filters?.clinic_ids?.length > 0) {
        copyFilters = { ...copyFilters, city_id: null };
      }
      fetchAvailableSlots({
        ...copyFilters,
        slot_status: "0",
      });
    }
  };
  return execute;
};
